import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/* Brand mark used across every page.

   Now clickable: routes to `/homepage` when the user is signed in, otherwise
   back to the public landing (`/`). The visual treatment is unchanged — we
   still render "Sales" in white + "Pit" in red with the same italic heading
   font — the only difference is that the mark is a real button, so it is
   keyboard-focusable, screen-reader friendly, and shows a subtle opacity
   fade on hover to signal it's interactive. */

export const Logo = ({ className = "text-2xl" }) => {
  const navigate = useNavigate();
  const { status } = useAuth();

  const handleClick = () => {
    navigate(status === "authenticated" ? "/homepage" : "/");
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="SalesPit — home"
      data-testid="salespit-logo"
      className={`font-heading font-black tracking-tighter italic select-none cursor-pointer bg-transparent border-0 p-0 m-0 transition-opacity duration-200 hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E52525]/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0A0A0A] rounded-sm ${className}`}
    >
      <span className="text-white">Sales</span>
      <span className="text-[#E52525]">Pit</span>
    </button>
  );
};
